import "./pages.css";
import Footer from "../Home/footer";
import Header from "../Home/header";
const Privacy = () => {
  return (
    <>
      <Header />
      <div className="blg">
        <div className="headblogs">
          <div className="titlehead">
            <h2 className="h2"> iptv-store Refund Policy</h2>
          </div>
        </div>
        <div className="aboutus">
          <p className="paraaboutus">
            Please read the following carefully, then send us a refund request
            by creating a ticket in the support section. Requests for Refund
            must be clear and acceptable: √ Before you buy, be sure to request a
            trial account. We have set up a trial account so that you can test
            it and if you are not satisfied, do not buy a long-term service. √
            If your internet speed is slow, you will not be able to see and use
            our iptv-store services and then request a refund. √ The big
            iptv-store team is always ready to respond 24 hours a day, seven
            days a week, and if you can't set up the iptv-store service on the
            devices you have for any reason, it won't include refunds. Please
            see and learn the necessary tutorials on setting up iptv. √ If you
            made a mistake in choosing the service and completed the payment,
            you can find a ticket in the support section entitled; Create then
            our support team will review it and accept and do the refund. ;
            Payment error; This means that you want to buy a 3-month service and
            have mistakenly chosen and paid for a year or less. √ If your
            account expires 7 days later, the refund request will not be
            accepted.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;
